import React from 'react';
import Link from 'gatsby-link';

import logo from '../images/transparent_name.png';

const Header = () => (
  <div id="header">
    <Link to="/">
      <img id="logo" src={logo} />
    </Link>
    <nav className="menu">
      <ul>
        <li>
          <Link to="/videos" activeClassName="active">
            Let&apos;s play!
          </Link>
        </li>
        <li>
          <Link to="/manual" activeClassName="active">
            Manual
          </Link>
        </li>
        <li>
          <Link to="/faq" activeClassName="active">
            FAQ
          </Link>
        </li>
        <li>
          <a href="https://boardgamegeek.com/boardgame/235836/legacy-stars">
            BGG Page
          </a>
        </li>
      </ul>
    </nav>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/layouts/header.js